module.exports = __webpack_public_path__ + "static/media/icon_import_round.b7110205.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon_import_round.svg
// module id = 354
// module chunks = 0